export default {
    name: "neo-multiselect-template",
    components: {},
    props: {
        properties: Object,
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
